import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { findDivisionAct, loadDivisionByIdAct, saveDivisionAct, saveSuccessDivisionAct, setViolationsDivisionAct, showMsgErrorAct, updateDivisionAct, updateSuccessDivisionAct } from "./division.actions";
import { DivisionService } from "../../services/division.service";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class DivisionEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private divisionService = inject(DivisionService);
    private alerta = inject(AlertaService);
    
    /*CRUD CATALOG DIVISION*/
    /*getAllDivisionsCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(getAllDivisionsCatalogAct),
            exhaustMap(() => this.catalogService.getAllDivisions()
        .pipe(
            map(divisions => loadAllDivisionsCatalogAct({ divisions })),
            catchError(error => of(error))
        ))
        )
    );*/

    findDivisionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findDivisionAct),
            exhaustMap(action => this.divisionService.getDivisionById(action.id)
        .pipe(
            map(division => loadDivisionByIdAct({ division })),
            catchError(error => of(error))
        ))
        )
    );

    saveDivisionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveDivisionAct),
            exhaustMap(action => this.divisionService.saveDivision(action.divisionNew)
                .pipe(
                    map(divisionNew => saveSuccessDivisionAct({ divisionNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsDivisionAct({ divisionForm: action.divisionNew, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))                        
                    )
                )
            )
        )
    );

    saveSuccessDivisionEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessDivisionAct),
        tap(() => {
            this.router.navigate(['/divisions']);
                this.alerta.correct("División creada con exito");
            })
        ), { dispatch: false }
    );

    updateDivisionEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateDivisionAct),
            exhaustMap(action => this.divisionService.updateDivision(action.divisionUpdated)
                .pipe(
                    map(divisionUpdated => updateSuccessDivisionAct({ divisionUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsDivisionAct({ divisionForm: action.divisionUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    
    updateSuccessDivisionEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessDivisionAct),
        tap(() => {
            this.router.navigate(['/divisions']);
            this.alerta.correct("División editada con exito");
        })
    ), {dispatch: false});
    /*CRUD CATALOG DIVISION END*/

    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
            tap((action) => {
                this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
            })
        ), { dispatch: false }
    );
    
    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;                obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}